import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // << ตรงนี้ต้องมี!

import './assets/index.css'

createApp(App).use(router).mount('#app')
